(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("weappUtils"), require("loadjs"));
	else if(typeof define === 'function' && define.amd)
		define(["weappUtils", "loadjs"], factory);
	else if(typeof exports === 'object')
		exports["weappEcodesdk"] = factory(require("weappUtils"), require("loadjs"));
	else
		root["weappEcodesdk"] = factory(root["weappUtils"], root["loadjs"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 